import type { FileInfo } from '@/shared/types/files';

export enum ILessonFormat {
  Online = 'online',
  Offline = 'offline',
  Meeting = 'meeting',
}

export enum LessonTypeEnum {
  Regular = 'regular',
  Exam = 'exam',
  Resubmission = 'resubmission',
}
// Video types
/**
 * Видео Cloudflare Stream. Ссылки подписаны и живут до `urlExpiresAt`: ответ с видео
 * перезапрашивается до этого срока (useRefreshOnVideoUrlExpiry), ссылки не хранятся
 * и из uid не собираются.
 */
export interface ILessonVideo {
  id: number;
  name: string;
  size: number;
  mime: string;
  duration: number;
  url: string;
  embedUrl: string;
  thumbnailUrl: string | null;
  /** когда url/embedUrl/thumbnailUrl перестанут работать; null — ссылки бессрочные */
  urlExpiresAt: string | null;
}

export type ContentMode = 'legacy' | 'steps';

export type ContentStepType = 'general' | 'video' | 'scorm';

export type LessonCompletionReason = 'assignment' | 'assignment_and_scorm' | 'scorm' | 'scheduled';

export interface IStepScorm {
  packageId: number;
  title: string;
  version: string;
  hasAssessment: boolean;
  passingScore: number | null;
}

export interface IStepScormSession {
  id: number;
  completionStatus: string;
  successStatus: string;
  scoreScaled: number | null;
  progressMeasure: number | null;
  lastActivityAt: string | null;
  totalTime: number;
}

export interface IStudentStepScorm extends IStepScorm {
  session: IStepScormSession | null;
  isCompleted: boolean;
}

export interface IContentStep<TScorm extends IStepScorm = IStepScorm> {
  id: number;
  order: number;
  type: ContentStepType;
  title: string | null;
  description: string | null;
  content: string | null;
  attachments: FileInfo[];
  video: ILessonVideo | null;
  scorm: TScorm | null;
}

export type IStudentContentStep = IContentStep<IStudentStepScorm>;

// Author types
export interface ILessonNoteAuthor {
  id: number;
  username: string;
  email: string;
  avatar?: string | null;
  role?: string;
}

// Note types
export interface ILessonNote {
  id: number;
  author: ILessonNoteAuthor;
  message: string;
  createdAt: string;
  attachments: FileInfo[];
}

// Lesson types for navigation and progress
export interface ILessonNavigation {
  id: number;
  order: number;
  title: string;
  isExam?: boolean;
  type?: LessonTypeEnum;
  groupLessonId?: number | null;
  groupExamResubmissionId?: number | null;
  isCompleted?: boolean;
}
